import {createSlice} from '@reduxjs/toolkit';

// ---- import from local actions ----
import {fetchUserList} from './../actions/UserActions';


const UserSlice = createSlice({
  name: 'user',
  initialState: {
    userList: {
      data: [],
      status: 'idle',
      error: '',
      loading: false,
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(fetchUserList.pending, (state) => {
        state.userList.status = 'loading';
      })
      .addCase(fetchUserList.fulfilled, (state, action) => {
        state.userList.status = 'idle';
        state.userList.data = action.payload.result;
      })
      .addCase(fetchUserList.rejected, (state, action) => {
        state.userList.status = 'rejected';
        state.userList.error = action.error.message;
      });
  },
});

export default UserSlice.reducer;
